module.exports = __webpack_public_path__ + "img/services-shape.ed6fc5b3.svg";